import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/apple-pay': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M116.9 158.5C109.4 167.4 97.4 174.4 85.4 173.4 83.9 161.4 89.8 148.6 96.7 140.8 104.2 131.7 117.3 125.2 128 124.7 129.2 137.1 124.3 149.4 116.9 158.5M127.8 175.7C110.4 174.7 95.5 185.6 87.3 185.6 78.9 185.6 66.3 176.2 52.5 176.5 34.6 176.8 18 186.9 8.9 203-9.9 235.3 4 283 22.2 309.3 31.1 322.3 41.7 336.6 55.7 336.1 69 335.6 74.2 327.5 90.2 327.5 106.3 327.5 111 336.1 125 335.9 139.5 335.6 148.6 322.9 157.5 309.9 167.6 295.1 171.8 280.8 172 280 171.7 279.7 144 269.1 143.7 237.1 143.4 210.3 165.6 197.6 166.6 196.8 154.1 178.2 134.6 176.2 127.8 175.7M228.2 139.5V334.4H258.5V267.8H300.4C338.7 267.8 365.5 241.5 365.5 203.5S339.1 139.5 301.4 139.5H228.2zM258.5 165H293.4C319.7 165 334.7 179 334.7 203.6S319.7 242.4 293.3 242.4H258.5V165zM420.7 335.9C439.7 335.9 457.3 326.3 465.3 311H465.9V334.4H493.9V237.4C493.9 209.3 471.4 191.1 436.8 191.1 404.7 191.1 380.9 209.5 380 234.7H407.3C409.6 222.7 420.7 214.8 435.9 214.8 454.4 214.8 464.8 223.4 464.8 239.3V250.1L427 252.4C391.9 254.5 372.9 268.9 372.9 293.9 373 319.1 392.6 335.9 420.7 335.9zM428.9 312.8C412.8 312.8 402.5 305 402.5 293.2 402.5 280.9 412.4 273.8 431.3 272.7L464.9 270.6V281.6C464.9 299.8 449.4 312.8 428.9 312.8zM531.4 387.4C560.9 387.4 574.8 376.1 586.9 342L640 193H609.2L573.6 308.1H573L537.4 193H505.8L557 334.9 554.2 343.5C549.6 358.1 542.1 363.8 528.7 363.8 526.3 363.8 521.7 363.5 519.8 363.3V386.7C521.6 387.1 529.1 387.4 531.4 387.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/apple-pay.js
// module id = IaAS
// module chunks = 144